module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.history) ? _c('linechart', {
    attrs: {
      "title": "Hashrate History",
      "width": "1750",
      "height": "820",
      "data": _vm.history,
      "margin": {
        top: 20,
        right: 80,
        bottom: 30,
        left: 10
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-308a5f98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Graph.vue
// module id = 788
// module chunks = 1